import { ApplicantFinalizeExamStatus } from "../store/workspace/types";

interface FinalizeAction {
    title: string;
    id: ApplicantFinalizeExamStatus;
}

export const examStatsDefaultActions = [
    {
        id: 'interview',
        title: 'Add to personal interview'
    },
    {
        id: 'finalResult',
        title: 'Add to final results'
    },
];

export const interviewActions = [
    {
        id: 'finalResult',
        title: 'Add to final results'
    },
];

export const finalResultActions: FinalizeAction[] = [
    {
        id: 'notAMatch',
        title: 'Not a match'
    },
    {
        id: 'moreInterview',
        title: 'More interview'
    },
    {
        id: 'inProcess',
        title: 'In process'
    },
    {
        id: 'sentOffer',
        title: 'Sent offer'
    },
    {
        id: 'hired',
        title: 'Hired'
    },
];

export const plansEnum = {
    freeTrial: 'Free trial',
    perUse: 'Per use',
    standard: 'Standard',
    professional: 'Professional',
    enterprise: 'Enterprise',
};